import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql, useStaticQuery } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';

import Link from '../Atoms/Link';
import { ImageGatsby } from '../Atoms/Image';

const imageQuery = graphql`
{
  rolex3: file(base: {eq: "Rolex-3.jpg"}) {
    childImageSharp {
      gatsbyImageData(
        width: 500
        placeholder: DOMINANT_COLOR
      )
    }
  }
  rolex2: file(base: {eq: "Rolex-2.jpg"}) {
    childImageSharp {
      gatsbyImageData(
        width: 500
        placeholder: DOMINANT_COLOR
      )
    }
  }
  rolex1: file(base: {eq: "Rolex-1.jpg"}) {
    childImageSharp {
      gatsbyImageData(
        width: 700
        placeholder: DOMINANT_COLOR
      )
    }
  }
}

`

const FollowUs = () => {
  const { t } = useTranslation();

  const { rolex3, rolex2, rolex1 } = useStaticQuery(imageQuery);

  return (
    <section className="py-12 px-4 lg:px-8">
      <div className='max-w-screen-2xl w-full mx-auto flex flex-col lg:flex-row'>
        <div className="lg:w-1/12 lg:block hidden" />
        <div className="lg:w-3/12 pr-8">
          <h3 className="text-xl font-cirka mb-5">{t('followUs.subtitle')}</h3>
          <h2 className="text-primary text-4xl md:text-5xl font-cirka mb-10">{t('followUs.title')}</h2>
          <Link to="https://www.facebook.com/Watchproject21" className="text-primary font-light font-roboto flex items-center my-8 no-animation">
            {t('followUs.on.facebook')}
          </Link>
          <Link to="https://www.instagram.com/watchproject21/" className="text-primary font-light font-roboto flex items-center my-8 no-animation">
            {t('followUs.on.instagram')}
          </Link>
        </div>
        <div className="lg:w-1/12 lg:block hidden" />
        <div className="lg:w-7/12 grid grid-cols-2 gap-5 gap-y-10">
          <div className="h-85 md:h-600 bg-cover relative col-span-2 md:col-span-1 row-span-2 overflow-hidden w-3/4 lg:w-full">
            <ImageGatsby image={getImage(rolex1)} alt="Rolex" width="100%" className="absolute top-0 -z-10 object-cover h-85 md:h-600" />
          </div>
          <div className="h-56 md:h-85 bg-cover relative overflow-hidden">
            <ImageGatsby image={getImage(rolex2)} alt="Rolex" className="absolute top-0 -z-10 object-cover w-full h-56 md:h-85" />
          </div>
          <div className="h-56 md:h-85 bg-cover relative overflow-hidden">
            <ImageGatsby image={getImage(rolex3)} alt="Rolex" className="absolute top-0 -z-10 object-cover w-full h-56 md:h-85" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default FollowUs;
